var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 673,
    height: 665,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-871 -754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.697 997.203 1063.91 993.994 998.016 830.571 1148.65 930.957 1196.47 761.572 1255.99 927.208 1399.25 816.56 1344.92 984.18 1528.91 974.532 1381.48 1080.11 1535.91 1175.15 1351.71 1178.36 1417.59 1341.78 1266.96 1241.4 1219.14 1410.78 1159.62 1245.15 1016.36 1355.8 1070.69 1188.17 886.702 1197.82 1034.13 1092.24Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFE340",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.94 1032.79 1121.47 1030.87 1081.93 932.814 1172.31 993.045 1201 891.414 1236.72 990.796 1322.67 924.407 1290.08 1024.98 1400.47 1019.19 1312.01 1082.54 1404.67 1139.56 1294.15 1141.49 1333.68 1239.54 1243.3 1179.31 1214.61 1280.94 1178.9 1181.56 1092.94 1247.95 1125.53 1147.38 1015.14 1153.16 1103.6 1089.82Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FCCC00",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco5);
export default __webpack_public_path__ + "static/media/deco5.dbe05fb47d76e393de1c1511c7559277.svg";
export { ForwardRef as ReactComponent };